import React, { PureComponent } from "react";
import FieldRowWrapper from "../FieldRowWrapper/FieldRowWrapper";
import vMasker from "vanilla-masker";
import classnames from "classnames";
import Calender from "./Calender";
import ClickOutside from "react-clickoutside-component";
import moment from "moment-jalaali";
import { toPersianDigit } from "../../../helpers/nums";

import "./date-input.css";
import "./calender.css";

moment.loadPersian();

// const reverseString = string =>
//   string
//     .split('')
//     .reverse()
//     .join('')

// function replaceLastInstance(string, charToReplace, Replacement) {
//   return reverseString(reverseString(string).replace(charToReplace, Replacement))
// }

var persian = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
var english = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

const perToEngMapper = char => {
  if (english.indexOf(char) !== -1 && persian.indexOf(char) !== -1) {
    // return null if it is neither persian nor english number
    // because it a alphabetic char
    return null;
  } else if (persian.indexOf(char) !== -1) {
    return english[persian.indexOf(char)];
  } else if (english.indexOf(char) !== -1) {
    return char;
  }
};

const ensureEnglishNumber = text => {
  if (typeof text === "string") {
    return text
      .split("")
      .map(perToEngMapper)
      .filter(char => !!char)
      .join("");
  } else {
    return "";
  }
};

const toGregorianDate = dateString =>
  moment(dateString, "jYYYY-jMM-jDDThh:mm")
    .utc()
    .toISOString();

const toJalaaliDate = (dateString, withTime = false) => {
  const format = withTime ? "jYYYY-jMM-jDDTHH:mm" : "jYYYY-jMM-jDD";
  return moment
    .utc(dateString)
    .local()
    .format(format);
};

const DatePicker = ({ onChange, isActive }) => (
  <div className={classnames({ calender: true, active: isActive })}>
    <Calender onChange={onChange} />
  </div>
);

// adapters between calender and this component
// and between this component and it's parent
const calenderToInputRegex = new RegExp("/", "g");

export default class DateInput extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasFocus: false,
      maskedValue: "",
      isDatePickerActive: false
    };
  }

  maskDate = rawValue => vMasker.toPattern(rawValue, "9999-99-99-99:99");

  unMaskDate = rawValue => rawValue.replace(calenderToInputRegex, "-");

  onInputChange = event => {
    this.updateValue({
      value: event.target.value,
      shouldUpdateParent: true
    });
  };

  updateValue = ({ value, shouldUpdateParent }) => {
    const maskedValue = this.maskDate(ensureEnglishNumber(value));

    this.setState({ maskedValue }, () => {
      shouldUpdateParent && this.props.onChange(toGregorianDate(maskedValue));
    });
  };

  componentDidMount = () => {
    // makes this component hybrid, if there is a value prop
    // it will respect it but otherwise it is independent 🍺👍
    const { value } = this.props;

    if (value) {
      this.updateValue({
        value: toJalaaliDate(value, true),
        shouldUpdateParent: false
      });
    }
  };

  onInputFocus = () => {
    this.setState(
      {
        hasFocus: true,
        isDatePickerActive: true
      },
      () => {
        this.props.onFocus && this.props.onFocus();
      }
    );
  };

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur();
    });
  };

  getInputValue = () => toPersianDigit(this.state.maskedValue);

  /**
   * @param {Moment} value a "jMoment" object
   */
  onCalenderInput = momentDate => {
    this.updateValue({
      value: momentDate.format("jYYYY-jMM-jDDTHH:mm"),
      shouldUpdateParent: true
    });
  };

  requestCalenderClose = () => {
    this.setState({ isDatePickerActive: false });
  };

  render() {
    const {
      name = "",
      placeholder = "__:__ - __ - __ - __ ۱۳",
      touched,
      error
    } = this.props;

    const classNames = {
      "formz-date-input": true,
      "formz-has-focus": this.state.hasFocus,
      "formz-has-error": this.props.error,
      "full-width": this.props.fullWidth
    };

    return (
      <FieldRowWrapper className={classNames} error={error} touched={touched}>
        <ClickOutside onClickOutside={this.requestCalenderClose}>
          <div className="formz-field-and-label-holder">
            <input
              type="text"
              name={name}
              value={this.getInputValue()}
              className="formz-input-field ltr"
              placeholder={placeholder}
              onChange={this.onInputChange}
              onFocus={this.onInputFocus}
              onBlur={this.onInputBlur}
            />

            <DatePicker
              isActive={this.state.isDatePickerActive}
              onChange={this.onCalenderInput}
            />
          </div>
        </ClickOutside>
      </FieldRowWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/DateInput/DateInput.js